import { PhilosophyListContext } from "../context/PhilosophyListContext";
import { useContext } from "react";

export const usePhilosophyListContext = () => {
    const context = useContext(PhilosophyListContext);

    if (!context) {
        return Error('usePhilosophyListContext must be used inside an PhilosophyListContextProvider');
    };

    return context;
};